export const supportCards = [
  {
    id: "contact-support",
    title: "Contact Support",
    description: "Connect directly with our support specialists for immediate assistance with your account and service inquiries.",
    icon: "ri-customer-service-2-line",
    bgColor: "bg-black",
    iconBg: "bg-black",
    iconColor: "text-white",
    cardBg: "bg-white",
    textColor: "text-black",
    path: "/contact-support",
  },
  {
    id: "dispute-resolution",
    title: "Dispute Resolution Form",
    description: "Submit formal dispute resolution requests through our structured process for comprehensive issue resolution.",
    icon: "ri-file-text-line",
    bgColor: "bg-white",
    iconBg: "bg-white",
    iconColor: "text-black",
    cardBg: "bg-black",
    textColor: "text-white",
    path: "/dispute-resolution",
  },
];

export const subscriptionCards = [
  {
    id: "cancelling-subscription",
    title: "Cancelling my subscription",
    description: "Learn how to cancel your subscription and understand the cancellation process.",
    icon: "ri-close-circle-line",
    path: "/article/cancelling-my-subscription",
  },
  {
    id: "auto-renew",
    title: "Does my subscription automatically renew?",
    description: "Understand how subscription renewals work and how to manage them.",
    icon: "ri-refresh-line",
    path: "/article/does-my-subscription-automatically-renew",
  },
  {
    id: "never-received",
    title: "What if I never received the product or service?",
    description: "Get help when you haven't received your purchased product or service.",
    icon: "ri-question-line",
    path: "/article/what-if-i-never-received-the-product-or-service",
  },
];

export const billingCards = [
  {
    id: "refund",
    title: "Where is my refund?",
    description: "Track your refund request and understand processing timelines.",
    icon: "ri-refund-2-line",
    path: "/article/where-is-my-refund",
  },
  {
    id: "unrecognized-charge",
    title: "I don't recognize this charge — what should I do?",
    description: "Report and resolve charges you don't recognize on your account.",
    icon: "ri-bank-card-line",
    path: "/article/i-dont-recognize-this-charge",
  },
  {
    id: "unaware-charges",
    title: "I was unaware of the charges",
    description: "Get help with charges you weren't aware of or didn't authorize.",
    icon: "ri-alert-line",
    path: "/article/i-was-unaware-of-the-charges",
  },
];

export const companyInfo = {
  name: "Vantory Labs LTD",
  address: [
    "109-111 Fulham Palace Road",
    "London",
    "W6 8JA",
    "United Kingdom",
  ],
  email: "clientservice@vantorylabs.com",
  phone: "+447451257361",
};

export const articleContent: Record<string, { title: string; content: string }> = {
  "cancelling-my-subscription": {
    title: "Cancelling my subscription",
    content: `To cancel your subscription, please follow these steps:

1. Log in to your account on our platform

2. Navigate to Account Settings or Subscription Management

3. Locate the Cancel Subscription option

4. Follow the on-screen prompts to complete cancellation

Please note that cancellation may take up to 48 hours to process. You will continue to have access to your subscription benefits until the end of your current billing period. If you need immediate assistance, please contact our support team directly.`,
  },
  "does-my-subscription-automatically-renew": {
    title: "Does my subscription automatically renew?",
    content: `Yes, all subscriptions automatically renew at the end of each billing period unless you choose to cancel.

By default, subscriptions are set to auto-renew to ensure uninterrupted access to our services. You can manage your renewal settings at any time through your account dashboard.

To disable auto-renewal:

1. Log in to your account

2. Go to Subscription Settings

3. Toggle off Auto-Renewal

4. Confirm your choice

You will receive a reminder email 7 days before your subscription renews.`,
  },
  "what-if-i-never-received-the-product-or-service": {
    title: "What if I never received the product or service?",
    content: `If you have not received your purchased product or service, please take the following steps:

1. Check your email (including spam/junk folders) for delivery confirmation or access instructions

2. Verify that the email address associated with your account is correct

3. Allow up to 24 hours for digital products to be processed

If you still haven't received your product or service after 24 hours, please contact our support team immediately with your order number and purchase details. We will investigate and resolve the issue promptly.

For physical products, please allow 5-10 business days for delivery depending on your location.`,
  },
  "where-is-my-refund": {
    title: "Where is my refund?",
    content: `Refund processing typically takes 5-10 business days from the date of approval.

The timeline depends on your original payment method:

- Credit/Debit Cards: 5-10 business days

- PayPal: 3-5 business days

- Bank Transfers: 7-14 business days

You can check the status of your refund request by logging into your account and visiting the Order History section. If your refund has been approved but you haven't received it within the expected timeframe, please contact our billing team with your refund reference number.

Note: Some banks may take additional time to process refunds, especially during weekends and holidays.`,
  },
  "i-dont-recognize-this-charge": {
    title: "I don't recognize this charge — what should I do?",
    content: `If you see a charge you don't recognize, please follow these steps:

1. Check your email for any purchase confirmation that might match the charge date and amount

2. Ask family members or authorized users if they made the purchase

3. Log in to your account to review your order history

If you still don't recognize the charge after checking:

- Contact our support team immediately with the transaction details

- Provide the date, amount, and last 4 digits of the card used

- We will investigate and respond within 24-48 hours

For security concerns, you may also want to contact your bank or card issuer to dispute the charge while we investigate.`,
  },
  "i-was-unaware-of-the-charges": {
    title: "I was unaware of the charges",
    content: `We understand that unexpected charges can be concerning. Here's what you should know:

Our billing system sends email notifications before each charge, including:

- Upcoming renewal reminders (7 days before)

- Receipts immediately after payment

- Monthly usage summaries

If you were not aware of charges, it may be because:

- Emails went to your spam/junk folder

- The email address on your account is outdated

- Auto-renewal was enabled when you signed up

To resolve this:

1. Update your email preferences in Account Settings

2. Review your subscription details and renewal settings

3. Contact our support team if you believe the charges were made in error

We are committed to transparency in all billing matters and will work with you to resolve any concerns.`,
  },
};